// extracted by mini-css-extract-plugin
export default {"container":"events_container__XrR9U","title":"events_title__262fg","events":"events_events__2lxcO"};